import { Breadcrumb, PageLayout, type PageWidth } from '@psyomics/ui-components';
import { Outlet } from 'react-router-dom';

type MobileLayoutProps = {
  readonly width?: PageWidth;
};

const MobileLayout = ({ width = 'form' }: MobileLayoutProps) => (
  <PageLayout breadcrumb={<Breadcrumb />} width={width}>
    <Outlet />
  </PageLayout>
);

export { MobileLayout };
